module.exports = __webpack_public_path__ + "officialStatic/img/solution1.1f32067.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/solution1.png
// module id = EjDO
// module chunks = 0